import l from 'constants/localizationLabels';
// Import Enums
import { ObjectTypeEnum } from 'enums';

export const ObjectTypeIconsWithTitle = {
    [ObjectTypeEnum.Segment]: { icon: 'bc-icon-segment', title: l.Segment },
    [ObjectTypeEnum.Template]: { icon: 'bc-icon-template', title: l.Template },
    [ObjectTypeEnum.Campaign]: { icon: 'bc-icon-campaign', title: l.Campaign },
    [ObjectTypeEnum.Bonus]: { icon: 'bc-icon-bonus', title: l.Award },
    [ObjectTypeEnum.Workflow]: { icon: 'bc-icon-customer-journey', title: l.RealtimePromotion },
};
